import { render, staticRenderFns } from "./choiceMaintenanceStandard.vue?vue&type=template&id=650cded6&scoped=true&"
import script from "./choiceMaintenanceStandard.vue?vue&type=script&lang=js&"
export * from "./choiceMaintenanceStandard.vue?vue&type=script&lang=js&"
import style0 from "./choiceMaintenanceStandard.vue?vue&type=style&index=0&id=650cded6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cded6",
  null
  
)

export default component.exports